import client from "./base";

/**
 * @param Object data
 * @returns {Promise<Object>}
 */
export function login(data) {
    return client.post('/trainer/auth/login', data);
}
